import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import styles from './SeenBlock.scss';
import SeenBlockItem from './elements/SeenBlockItem';
import _ from 'lodash';
import InlineSVG from 'react-svg-inline';
import clockIcon from '../../imgs/clock-icon.svg';


export class SeenBlock extends Component {
  render() {
    const items = _.map(this.props.seenItems, (item, key) => (
    <SeenBlockItem key={`seenblockitem_${key}`} item={item} />));
    return (
      <div className={ styles.seenBlock }>
        <div className={ styles.seenBlockWrapper }>
          <InlineSVG svg={clockIcon} />
          {items}
        </div>
      </div>
    );
  }
}



SeenBlock.propTypes = {
};

function mapStateToProps(state) {
  return {
    ...state.appReducer
  };
}

export default connect(
  mapStateToProps,
  () => ({})
)(SeenBlock);



/** WEBPACK FOOTER **
 ** ./src/components/SeenBlock/SeenBlock.jsx
 **/